/* istanbul ignore file */
export { default as SuggestBox } from './SuggestBox';